import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorUserNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IUserModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
      firstName: string,
      lastName: string,
      fullName: string,
  }

export const IUserFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges",
    "firstName",
    "lastName",
    "fullName"
];

export function useUserHookNae(id: number) : IUserModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorUserNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.User.schema,
        fields: IUserFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
